import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getCheckSickNoteRequest: ["leave_id"],
  getCheckSickNoteSuccess: ["checkSickNote"],
  getCheckSickNoteFailure: null,
});

export const GetCheckSickNoteTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  data: null,
  fetching: null,
  payload: null,
  success: null,
  error: null,
  leave_id: null,
});

export const GetCheckSickNoteSelectors = {
  getData: (state: any) => state.getCheckSickNote.data,
  isFetching: (state: any) => state.getCheckSickNote.fetching,
  isSuccess: (state: any) => state.getCheckSickNote.success,
  hasError: (state: any) => state.getCheckSickNote.error,
};

export const request = (state: any, { leave_id }: any) => {
  const updateData = {
    fetching: true,
    success: null,
    error: null,
    leave_id,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { checkSickNote } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    checkSickNote,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    payload: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_CHECK_SICK_NOTE_REQUEST]: request,
  [Types.GET_CHECK_SICK_NOTE_SUCCESS]: success,
  [Types.GET_CHECK_SICK_NOTE_FAILURE]: failure,
});
